import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"

import {
  getRtgsBankTemplates,
  getRtgsBankTemplate,
  createRtgsBankTemplate,
  updateRtgsBankTemplate,
  deleteRtgsBankTemplate,
} from "api/rtgsBankTemplateApi"

export const RTGS_BANK_TEMPLATE_QUERY_KEY = "rtgs-bank-template"

export const useRtgsBankTemplates = (params = {}, enabled = true) => {
  return usePaginatedResource(
    RTGS_BANK_TEMPLATE_QUERY_KEY,
    getRtgsBankTemplates,
    params,
    enabled
  )
}

export const useRtgsBankTemplate = (id, enabled = true) => {
  return useResourceItem(
    RTGS_BANK_TEMPLATE_QUERY_KEY,
    getRtgsBankTemplate,
    id,
    enabled
  )
}

export const useCreateRtgsBankTemplate = () => {
  return useCreateResource(createRtgsBankTemplate, RTGS_BANK_TEMPLATE_QUERY_KEY)
}

export const useEditRtgsBankTemplate = () => {
  return useEditResource(updateRtgsBankTemplate, RTGS_BANK_TEMPLATE_QUERY_KEY)
}

export const useDeleteRtgsBankTemplate = () => {
  return useDeleteResource(deleteRtgsBankTemplate, RTGS_BANK_TEMPLATE_QUERY_KEY)
}
